module.exports = __webpack_public_path__ + "img/icon-resta.afeeaea6.svg";